<!-- 会员消费记录 -->

<template>
    <div class="vipRecharge">
        <div class="tableConBox">
            <div class="tableTem">
                <div class="HSpace1"></div>
                <div class="searchBox flex flex-align-center">
                   <div class="searchCon clearfix">
                        <div class="left searchBtn">
                            <button type="button" @click="showUpBox"><i class="el-icon-plus"></i>添加规则</button>
                        </div>
                    </div>
                </div>
                <div class="HSpace2"></div>
                <div class="tableBox">
                    <div class="tableBoxScroll">
                        <table class="titleTable">
                            <tr>
                                <th style="width:50%;text-align:left;padding-left:10%;">充值规则</th>
                                <th style="width:50%;text-align:right;padding-right:10%;">操作</th>
                            </tr>
                        </table>
                        <div class="scrollBox">
                            <div class="scroll">
                                <table class="conTable" :class="{overLengthTable:rulesData.length<10}">
                                    <tr v-for="item in rulesData">
                                        <td  style="width:50%;text-align:left;padding-left:10%;"><span v-text="item.name"></span></td>
                                        <td   style="width:50%;text-align:right;padding-right:10%;">
                                            <span title="修改" style="margin:0 2%;" v-if="item.id" @click="showUpBox(item)"><i class="iconfont icon-bianji"></i></span>
                                            <span title="删除" @click="delRules(item)" v-if="item.id"><i class="iconfont icon-icon1460188478041"></i></span>
                                        </td>
                                    </tr>
                                </table>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <el-dialog
            title="添加员工"
            :visible.sync="dialogVisible"
            size="tiny">
            <span>这是一段信息</span>
            <span slot="footer" class="dialog-footer">
                <el-button @click="dialogVisible=false">取 消</el-button>
                <el-button type="primary" @click="dialogVisible=false">确 定</el-button>
            </span>
        </el-dialog>
        <el-dialog
            :title="'添加充值规则'"
            :visible.sync="addRechargeBtn"
            size="tiny">
            <div>
                <div class="msgBox clearfix">
                    <div class="left msgItem clearfix">
                        <span class="left itemName"><i>*</i>充值金额</span>
                        <input type="text" class="left itemInput" v-model="deposit" placeholder="请输入充值金额" >
                    </div>
                    <div class="left msgItem clearfix">
                        <span class="left itemName">赠送金额</span>
                        <input type="text" class="left itemInput" v-model="bonus" placeholder="请输入赠送金额">
                    </div>
                </div>
            </div>
            <div class="show-name">
                <p>充值时显示名称（可修改）</p>
                <div><input type="text"  v-model="name"></div>
            </div>
            <span slot="footer" class="dialog-footer">
                <button type="button" @click="addRechargeBtn=false" class="cancel">取消</button>
                <button type="button" @click="rechargeFn" class="save">保存</button>
            </span>
        </el-dialog>
    </div>
</template>

<script type="text/javascript">
    import {url} from '@/router/url.js';
    export default{
        props: ['pageSize','curStoreId'],
    	data () {
    		return {
                dialogVisible: false,
                addRechargeBtn:false,//添加规则按钮
                rulesData:[],//规则列表
                deposit:'',//充值金额
                bonus:'',//赠送金额
                name:'充值'+(this.deposit?this.deposit:0)+'送'+(this.bonus?this.bonus:0),//显示名字
                rulesId:''//规则id
    		}
    	},

        watch:{
            deposit(val){
                this.name = '充值'+(val?val:0)+'送'+(this.bonus?this.bonus:0);
            },
            bonus(val){
                this.name = '充值'+(this.deposit?this.deposit:0)+'送'+(val?val:0);
            }
        },
        methods: {
            //删除规则
            delRules(item){
                this.$confirm('此操作将删除该充值规则, 是否继续?', '提示', {
                  confirmButtonText: '确定',
                  cancelButtonText: '取消',
                  type: 'warning'
                }).then(() => {
                    //删除规则
                    this.$http.delete('charge-rules/'+item.id).then((res)=>{
                        this.getRules();
                    })
                }).catch(() => {});
            },
            //新建或更新规则
            rechargeFn(id){
                if(!/^(0|[1-9][0-9]{0,9})(\.[0-9]{1,2})?$/.test(this.deposit)){
                    this.$message({
                        message: '充值金额格式有误',
                        customClass: 'error'
                    })
                    return;
                }
                if(!/^(0|[1-9][0-9]{0,9})(\.[0-9]{1,2})?$/.test(this.bonus)){
                    this.$message({
                        message: '赠送金额格式有误',
                        customClass: 'error'
                    })
                    return;
                }
                let sendBody = {
                    "storeId": this.curStoreId,
                    "name": this.name,
                    "depositAmount": parseFloat(this.deposit),
                    "bonusAmount": parseFloat(this.bonus)
                }
                this.$http.put('charge-rules/'+this.rulesId,sendBody).then((res)=>{
                    this.getRules();
                    this.addRechargeBtn = false;
                    this.deposit = '';
                    this.bonus = '';
                    this.$message({
                        message: '操作成功！',
                        customClass: 'success'
                    })
                })
            },
            showUpBox(item){
                this.name = item.name;
                this.rulesId = item.id?item.id:this.$uuid.create(1).hex;
                this.addRechargeBtn = true;
            },
            getRules(){
                //获取规则列表
                this.$http.get('charge-rules?storeId='+this.curStoreId).then((res)=>{
                    this.rulesData = res.data;
                    if( this.rulesData.length < this.pageSize ){
                        for(let i = 0, len = this.pageSize - this.rulesData.length; i < len; i++){
                            this.rulesData.push({})
                        }
                    }
                })
            }
        },
        created: function () {
            for (let i = 0; i < this.pageSize; i++) {
                this.rulesData.push({})
            }
        },
        activated: function () {
           this.getRules();
        }
    }
</script>
<style lang="scss">
    @import '../../../../static/css/common.scss';
    @import '../../tableTemplate/tableTem.scss';
    @import '../../tableTemplate/el-dialog.scss';
	@import "vipRecharge";
</style>



// WEBPACK FOOTER //
// vipRecharge.vue?ff427a2a